module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isFunction.js
// module id = 1421
// module chunks = 0